import React, { useState, useRef } from 'react'
import { ShortcutLink, WContainer } from '@next-nx/shared-ui/atoms'
import { CategoriaCard, FaqSearchAndMacroCategories } from '@next-nx/shared-ui/molecules'
import { CategorieFaqDetailInterface, FaqInterface } from '@next-nx/utils/types'
import { faqMacroCategories } from 'libs/shared-ui/utils/const'
import { useTrans, useTealium } from '@next-nx/hooks';
import { getTimestamp } from '@next-nx/utils';
import { useRouter } from 'next/router';
import styles from './FaqHub.module.sass'

interface Props {
  categorie: CategorieFaqDetailInterface[]
  faqsFrequenti: FaqInterface[]
  className?: string
}

const getAllFaqs = (categorie: CategorieFaqDetailInterface[]) => {
  let f: FaqInterface[] = []
  categorie.forEach((item) => {
    f = f.concat(item.faq)
  })
  return f
}

const FaqHub = (props: Props) => {
  const { categorie, faqsFrequenti, className = '' } = props

  const t = useTrans()

  const [selectedMacroCategory, setSelectedMacroCategory] = useState<string>(faqMacroCategories[0].key)
  const faqs = useRef<FaqInterface[]>(getAllFaqs(categorie))
  const router = useRouter()
  const { linkDataLayer } = useTealium()

  const handleTracking = (type: string = '', category: string = '', title: string = '') => {
    const action_timestamp = getTimestamp() 

    if(!!category.length === false) {
      let arrPath = router.asPath.split('?');
      arrPath = arrPath[0].split('/')
      category = arrPath[arrPath.length - 1]
    }
    
    linkDataLayer({
          virtual: 'action', 
          action_name: 'faq',  
          action_tech: 'click',
          action_type: type.replace(/\.|\/|\s+/g, '_').toLowerCase(),
          action_timestamp, 
          action_effect: 'faq_ricerca',
          faq_category: category.replace(/\-|\s+/g, '_').replace(/,/g, '').toLowerCase(),
          faq_title: title.replace(/\-|\s+/g, '_').replace(/,/g, '').toLowerCase(),
        })
  } 

  return (
    <div className={`${styles.root} ${className}`}>
      <FaqSearchAndMacroCategories
        selectedMacroCategory={selectedMacroCategory}
        macroCategoryOnClick={setSelectedMacroCategory}
        faqs={faqs.current} 
      />
      <div className={styles.categories}>
        <WContainer>
          <h2 className={styles.categories_title}>{t('Seleziona un argomento di tuo intaresse')}</h2>
          <div className={`${styles.categories_box} ${selectedMacroCategory === faqMacroCategories[1].key ? styles.categories_box_second : ''}`}>
            {faqMacroCategories.map((item) => (
              <React.Fragment key={item.key}>
                {selectedMacroCategory === item.key && (
                  <> 
                    {categorie.map((item, index) => (
                      <React.Fragment key={'cat-' + item.slug}>
                        {selectedMacroCategory === item.macroCategoria && (
                          <div
                            className={`${styles.categories_item} ${
                              selectedMacroCategory === faqMacroCategories[1].key
                                ? styles.categories_item_second
                                : ''
                            }`}
                          >
                            <CategoriaCard
                              className={styles.categories_card}
                              iconStyleName={item.chiaveIcona}
                              itemText={item.titolo}
                              itemUrl={item.url}
                              animationVariant={index % 2 ? 'se' : 'nw'}  
                              handleTracking={handleTracking}
                              interazioneName='faq'                  
                              />
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  </>
                )}
              </React.Fragment>
            ))}
          </div>
        </WContainer>
      </div>
      <div className={styles.frequently_questions}>
        <WContainer>
          <h2 className={styles.frequently_questions_title}>{t('Alcune domande più frequenti')}</h2>
          <div className={styles.frequently_questions_box}>
            {faqsFrequenti.map((item, index) => (
              <ShortcutLink
                key={'faq-' + item.url}
                itemName={item.domanda}
                itemUrl={item.url}
                className={styles.frequently_questions_item} 
                handleTracking={handleTracking}
                />
            ))}
          </div>
        </WContainer>
      </div>
    </div>
  )
}

export default FaqHub
